import { FieldErrors } from 'react-hook-form';
import { ExternalScheduleFormValues } from '@forms/schedules/external/types';
import { ExternalScheduleDialogType } from './types';
import { visibleFields } from './constants';

export const getHiddenErrorFields = (
  errors: FieldErrors<ExternalScheduleFormValues>,
  type: ExternalScheduleDialogType,
) =>
  Object.keys(errors).filter(
    (key) => !visibleFields[type].includes(key as keyof ExternalScheduleFormValues),
  );
